import isObject from 'lodash/isObject';
import reduce from 'lodash/reduce';
import merge from 'lodash/merge';
import { load, dump } from 'js-yaml';
import { MigrateOptions } from '@aison/migrator';

export function flattenKeys(obj, path: string[] = []) {
  return !isObject(obj)
    ? { [path.join('.')]: obj }
    : reduce(
        obj,
        (cum, next, key) => {
          return merge<object, object>(cum, flattenKeys(next, [...path, key]));
        },
        {}
      );
}

export function downloadFile(
  content: string,
  { name = 'migration.yaml', type = 'application/yaml' } = {}
) {
  const blob = new Blob([content], { type });
  const link = document.createElement('a');
  // TODO: Make sure this is correctly set
  link.href = window.URL.createObjectURL(blob);
  link.download = name;
  link.click();
}

export function getStringFromFileChangeEvent(event): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    // getting a hold of the file reference
    const data = (event.target as any)?.files[0];

    // setting up the reader
    const reader = new FileReader();
    reader.readAsText(data, 'UTF-8');

    // here we tell the reader what to do when it's done reading...
    reader.onload = readerEvent => {
      const content = readerEvent.target?.result; // this is the content!
      if (typeof content === 'string') {
        resolve(content);
      } else {
        reject('Unable to parse config upload, expected string:' + content);
      }
    };
  });
}

export function serializeConfig(config: MigrateOptions): string {
  const serialized = dump(config, {
    noRefs: true,
    skipInvalid: true,
  });
  return serialized;
}

export function serializeMultipleConfigs(configs: MigrateOptions[]): string {
  const serialized = configs.map(serializeConfig);

  return '---\n' + serialized.join('\n---\n');
}

export function parseConfig(content: string): MigrateOptions {
  return load(content) as MigrateOptions;
}

export function parseMultipleConfigs(content: string): MigrateOptions[] {
  const configs = content.split('\n---\n');
  return configs.map(config => load(config) as MigrateOptions);
}

// BUNYAN PRETTY PRINTING
//see https://github.com/rlidwka/sinopia/blob/master/lib/logger.js
// function getlvl(x) {
//   switch (true) {
//     case x < 15:
//       return 'trace';
//     case x < 25:
//       return 'debug';
//     case x < 35:
//       return 'info';
//     case x == 35:
//       return 'http';
//     case x < 45:
//       return 'warn';
//     case x < 55:
//       return 'error';
//     default:
//       return 'fatal';
//   }
// }
//
// // level to color
// const levels = {
//   fatal: 31,
//   error: 31,
//   warn: 33,
//   http: 35,
//   info: 36,
//   debug: 90,
//   trace: 90,
// };
//
// let max = 0;
// for (const l in levels) {
//   max = Math.max(max, l.length);
// }
//
// function pad(str) {
//   if (str.length < max) return str + ' '.repeat(max - str.length);
//   return str;
// }
//
// const subsystems = [
//   // {
//   // in: '\033[32m<--\033[39m',
//   // out: '\033[33m-->\033[39m',
//   // fs: '\033[90m-=-\033[39m',
//   // default: '\033[34m---\033[39m',
//   // },
//   {
//     in: '<--',
//     out: '-->',
//     fs: '-=-',
//     default: '---',
//   },
//   {
//     in: '<--',
//     out: '-->',
//     fs: '-=-',
//     default: '---',
//   },
// ];
//
// export function print(type, msg, obj, colors) {
//   if (typeof type === 'number') type = getlvl(type);
//   const finalmsg = msg.replace(/@{(!?[$A-Za-z_][$0-9A-Za-z._]*)}/g, function(
//     _,
//     name
//   ) {
//     let str = obj,
//       isError;
//     if (name[0] === '!') {
//       name = name.substr(1);
//       isError = true;
//     }
//
//     const _ref = name.split('.');
//     for (let _i = 0; _i < _ref.length; _i++) {
//       const id = _ref[_i];
//       if (isObject(str) || Array.isArray(str)) {
//         str = str[id];
//       } else {
//         str = undefined;
//       }
//     }
//
//     if (typeof str === 'string') {
//       if (!colors || str.includes('\n')) {
//         return str;
//       } else if (isError) {
//         return str;
//         // return '\033[31m' + str + '\033[39m';
//       } else {
//         return str;
//         // return '\033[32m' + str + '\033[39m';
//       }
//     } else {
//       return require('util').inspect(str, null, null, colors);
//     }
//   });
//
//   const sub =
//     subsystems[colors ? 0 : 1][obj.sub] || subsystems[+!colors].default;
//   if (colors) {
//     return (
//       // ' \033[' +
//       levels[type] +
//       // 'm' +
//       pad(type) +
//       // '\033[39m ' +
//       sub +
//       // ' ' +
//       finalmsg
//     );
//   } else {
//     return ' ' + pad(type) + ' ' + sub + ' ' + finalmsg;
//   }
// }
